module.exports = __webpack_public_path__ + "img/wgk.f74bc2a0.png";